var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGcIcon = function SvgGcIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.658 13.695c0-.95-.085-1.86-.243-2.734H13.2v5.009l7.036.002a6.027 6.027 0 0 1-2.611 4.034v3.25h4.188c2.445-2.263 3.846-5.609 3.846-9.561Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.626 20.004c-1.166.786-2.667 1.246-4.423 1.246-3.392 0-6.27-2.286-7.301-5.367h-4.32v3.351c2.14 4.247 6.54 7.162 11.621 7.162 3.512 0 6.463-1.155 8.611-3.144l-4.188-3.248Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.495 13.402c0-.865.144-1.702.407-2.488V7.563h-4.32a12.936 12.936 0 0 0-1.383 5.839c0 2.1.5 4.083 1.383 5.84l4.32-3.352a7.842 7.842 0 0 1-.407-2.488Z",
    fill: "#FABB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.203 5.544c1.917 0 3.634.66 4.99 1.95l3.71-3.708C19.65 1.687 16.712.398 13.204.398c-5.08 0-9.48 2.915-11.621 7.162l4.32 3.351c1.03-3.08 3.908-5.367 7.3-5.367Z",
    fill: "#E94235"
  })));
};
export default SvgGcIcon;